import * as React from "react";

function MapPinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M16.001 2c-6.075 0-11 4.925-11 11 0 2.598.901 4.988 2.408 6.87l8.592 10.73 8.59-10.73a10.962 10.962 0 002.41-6.87c0-6.075-4.926-11-11-11zm0 25.4l-7.03-8.78A8.956 8.956 0 017 13a9 9 0 1116.03 5.621L16 27.401zM13 13a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10 5 5 0 000-10z",
    clipRule: "evenodd"
  }));
}

export default MapPinIcon;